import React from 'react';

export const LANG_KEY = 'prism_language';

export function getLang() {
  const stored = localStorage.getItem(LANG_KEY);
  if (stored === 'en' || stored === 'fr') return stored;
  return navigator.language?.startsWith('fr') ? 'fr' : 'en';
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang);
}

export default function LanguageToggle({ language, onToggle, className = '' }) {
  return (
    <div className={`lang-toggle-segmented ${className}`} role="group" aria-label="Language">
      <button
        className={`lang-seg-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => language !== 'en' && onToggle()}
        aria-pressed={language === 'en'}
      >
        EN
      </button>
      <button
        className={`lang-seg-btn ${language === 'fr' ? 'active' : ''}`}
        onClick={() => language !== 'fr' && onToggle()}
        aria-pressed={language === 'fr'}
      >
        FR
      </button>
    </div>
  );
}
